import { render, staticRenderFns } from "./app-expl-wrap.vue?vue&type=template&id=08cd9b14"
import script from "./app-expl-wrap.vue?vue&type=script&lang=ts"
export * from "./app-expl-wrap.vue?vue&type=script&lang=ts"
import style0 from "./app-expl-wrap.vue?vue&type=style&index=0&id=08cd9b14&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/volateq-web-app/volateq-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08cd9b14')) {
      api.createRecord('08cd9b14', component.options)
    } else {
      api.reload('08cd9b14', component.options)
    }
    module.hot.accept("./app-expl-wrap.vue?vue&type=template&id=08cd9b14", function () {
      api.rerender('08cd9b14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/shared/components/app-explanation/app-expl-wrap.vue"
export default component.exports